import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/resources/copy-link.svg'
import _imports_1 from '@/resources/preview_icon.svg'
import _imports_2 from '@/resources/copy.png'


const _hoisted_1 = { class: "request-container-invite" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flow-title" }, "Create Meeting Type"),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Invite Link")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "message-container" }, "Share this link via email, text message, or however you'd like", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "link-container"
}
const _hoisted_6 = { class: "invite-container flex-center" }
const _hoisted_7 = { class: "url-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "copyIcon",
    src: _imports_0
  })
], -1 /* HOISTED */)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "preview-container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "previewIcon",
    src: _imports_1
  })
], -1 /* HOISTED */)
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Copy Invite URL", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "copyImage",
  src: _imports_2
}, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon",
  src: "opt-app/src/resources/check-round.ico"
}, "✓", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "button-container invite-button"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Back to Home")
const _hoisted_19 = {
  key: 0,
  class: "preview-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["confirm-meeting-container meeting-container", {'no-scroll': $setup.noScroll}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!$setup.preview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              ($setup.offerUrl)
                ? (_openBlock(), _createBlock($setup["VQrCode"], {
                    key: 0,
                    message: $setup.offerUrl
                  }, null, 8 /* PROPS */, ["message"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("input", {
                    class: "url",
                    type: "text",
                    ref: "meetingLink",
                    readonly: "",
                    value: $setup.offerUrl
                  }, null, 8 /* PROPS */, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("input", {
                    class: "preview",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.preview = true)),
                    value: $setup.previewString,
                    readonly: ""
                  }, null, 8 /* PROPS */, _hoisted_12)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", { class: "buttons" }, [
          _createElementVNode("button", {
            class: "submit copy",
            onClick: $setup.copyToClipboard
          }, _hoisted_16)
        ])
      ]),
      (!$setup.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "borderless createInviteLink",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('restart')))
            }, "Create New Meeting Type"),
            _createVNode(_component_router_link, {
              class: "borderless toHome",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_Transition, {
        onBeforeEnter: _cache[3] || (_cache[3] = ($event: any) => ($setup.noScroll = true)),
        onAfterEnter: _cache[4] || (_cache[4] = ($event: any) => ($setup.noScroll = false)),
        onBeforeLeave: _cache[5] || (_cache[5] = ($event: any) => ($setup.noScroll = true)),
        onAfterLeave: _cache[6] || (_cache[6] = ($event: any) => ($setup.noScroll = false))
      }, {
        default: _withCtx(() => [
          ($setup.preview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode($setup["OptOffer"], {
                  offerLink: $props.instance.link,
                  "is-preview": true,
                  onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.preview = false))
                }, null, 8 /* PROPS */, ["offerLink"])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 2 /* CLASS */))
}